import type { CategoryConfig } from "@/types/movie";

export const categoryConfigs: CategoryConfig[] = [
  {
    slug: "popular",
    label: "热门",
    title: "热门电影推荐",
    description:
      "秋霞电影汇总当下最受关注的院线新作与话题影片，按热度与讨论度精选，帮你快速找到大家都在看的电影。",
    intro: "近期讨论度最高、最受观众欢迎的热门影片合集。",
    kind: "heat",
  },
  {
    slug: "latest",
    label: "最新",
    title: "最新上映影片",
    description:
      "秋霞电影整理最新上映的电影作品，涵盖科幻、悬疑、动作、剧情等多种类型，第一时间了解院线新片动态。",
    intro: "按上映时间排序的最新影片，第一时间掌握院线动态。",
    kind: "latest",
  },
  {
    slug: "classic",
    label: "经典",
    title: "经典佳作回顾",
    description:
      "秋霞电影精选经受住时间考验的经典影片，涵盖口碑高分与影史佳作，带你重温那些值得反复观看的优秀作品。",
    intro: "历年高口碑佳作，值得反复回味的经典影片。",
    kind: "classic",
  },
  {
    slug: "sci-fi",
    label: "科幻",
    title: "科幻电影精选",
    description:
      "秋霞电影为科幻爱好者精选宇宙探索、时间旅行与未来想象题材影片，感受想象力与视觉奇观的双重震撼。",
    intro: "从星际远征到时间旅行，感受硬核想象的魅力。",
    kind: "genre",
    genre: "科幻",
  },
  {
    slug: "action",
    label: "动作",
    title: "动作电影精选",
    description:
      "秋霞电影精选飙车、追凶与灾难营救题材动作影片，节奏紧凑、场面震撼，适合追求刺激观影体验的观众。",
    intro: "高能场面与紧张节奏，肾上腺素飙升的选择。",
    kind: "genre",
    genre: "动作",
  },
  {
    slug: "drama",
    label: "剧情",
    title: "剧情电影精选",
    description:
      "秋霞电影精选聚焦现实与人性的剧情影片，以细腻的叙事与真挚的情感，呈现普通人生活中的动人瞬间。",
    intro: "细腻叙事，直击人心的现实主义佳作。",
    kind: "genre",
    genre: "剧情",
  },
  {
    slug: "suspense",
    label: "悬疑",
    title: "悬疑电影精选",
    description:
      "秋霞电影精选烧脑反转、悬念迭起的悬疑影片，从罪案追查到未知恐惧，带你体验层层揭秘的观影乐趣。",
    intro: "环环相扣的悬念，专为推理爱好者准备。",
    kind: "genre",
    genre: "悬疑",
  },
  {
    slug: "romance",
    label: "爱情",
    title: "爱情电影精选",
    description:
      "秋霞电影精选浪漫治愈的爱情影片，从城市偶遇到岁月相守，用温柔的故事讲述关于相遇与陪伴的一切。",
    intro: "关于相遇、错过与相守的浪漫故事。",
    kind: "genre",
    genre: "爱情",
  },
  {
    slug: "animation",
    label: "动画",
    title: "动画电影精选",
    description:
      "秋霞电影精选画风精美、故事温暖的动画影片，适合全年龄段观众，兼顾视觉享受与情感共鸣。",
    intro: "画面与故事同样出色，适合全家一起观看。",
    kind: "genre",
    genre: "动画",
  },
];

export const genreOptions = [
  "科幻",
  "悬疑",
  "动作",
  "剧情",
  "爱情",
  "犯罪",
  "古装",
  "冒险",
  "战争",
  "家庭",
  "历史",
  "奇幻",
  "动画",
  "惊悚",
  "青春",
  "运动",
  "文艺",
  "灾难",
];

export const regionOptions = [
  "中国大陆",
  "中国香港",
  "中国台湾",
  "美国",
  "日本",
  "韩国",
  "英国",
  "法国",
];

export const yearOptions = ["2024", "2023", "2022", "2021"];